/**
 * Current WordPress version does not apply 'current-menu-item' class to pages with custom links. This function adds the class to a menu item that matches the current URL.
 */
function setCurrentMenuItemClass() {
  const menuItems = document.querySelectorAll('.wp-block-navigation-item');

  if (!menuItems.length) {
    return;
  }

  // Check for .current-menu-item class on any item and stop if found.
  for (let i = 0; i < menuItems.length; i += 1) {
    if (menuItems[i].classList.contains('current-menu-item')) {
      return;
    }
  }

  // Check for matching URL path on any child link of menuItems.
  for (let i = 0; i < menuItems.length; i += 1) {
    const link = menuItems[i].querySelector('a');
    const linkURL = new URL(link?.href);
    const url = window?.location;

    if (linkURL?.pathname === url?.pathname) {
      menuItems[i].classList.add('current-menu-item');
    }
  }
}

setCurrentMenuItemClass();
